import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MailService } from '../services/mail.service';

import { ConfirmationModalService, ModalTemplateComponent, AppSpinnerComponent } from '@nx-ahs/shared/components';

@Component({
	selector: 'app-view-pdf',
	templateUrl: './view-pdf.component.html',
	styleUrls: ['./view-pdf.component.scss'],
	standalone: true,
	imports: [CommonModule, NgxExtendedPdfViewerModule, ModalTemplateComponent, AppSpinnerComponent]
})
export class ViewPdfComponent implements OnInit {
	public mailFileId: number;
	public pdf: any;
	public loading: boolean;

	constructor(
		private mailService: MailService,
		public dialogRef: MatDialogRef<ViewPdfComponent>,
		@Inject(MAT_DIALOG_DATA) data,
		private confirmationModalService: ConfirmationModalService
	) {
		this.mailFileId = data['mailFileId'];
	}

	ngOnInit(): void {
		if (this.mailFileId) {
			this.loading = true;
			this.mailService
				.downloadMailFileById(this.mailFileId)
				.then((results) => {
					this.pdf = results;
				})
				.finally(() => {
					this.loading = false;
				});
		}

		this.dialogRef.keydownEvents().subscribe((event) => {
			if (event.key === 'Escape') {
				this.Close();
			}
		});
		this.dialogRef.backdropClick().subscribe(() => {
			this.Close();
		});
	}

	public Close(): void {
		this.confirmationModalService
			.showConfirmationDialog('Confirm Cancel', 'Click OK to continue')
			.beforeClosed()
			.toPromise()
			.then((result) => {
				if (result) {
					this.dialogRef.close(undefined);
				}
			});
	}
}
